import { cssProps } from '@oracle/oraclejet-cssprops';
import { InlineHelpSource } from './InlineHelpSource';

const helpTextStyles = cssProps`${{
  marginInlineEnd: '0.25rem',
  whiteSpace: 'pre'
}}`;

type Props = {
  assistiveText?: string;
  sourceLink?: string;
  sourceText?: string;
};

export function InlineHelp({ assistiveText, sourceLink, sourceText }: Props) {
  return (
    <div>
      {assistiveText && sourceLink ? (
        <span class={helpTextStyles}>{assistiveText}</span>
      ) : (
        assistiveText
      )}
      {sourceLink && <InlineHelpSource source={sourceLink}>{sourceText}</InlineHelpSource>}
    </div>
  );
}
